import React from 'react';

const Produk = () => {
  return <div>Produk (Kosong)</div>;
};

export default Produk;